// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { EntityElevationUpdate, EntityElevationUpdateT } from '../tbs/entity-elevation-update.js';


export class SetEntityElevationAction implements flatbuffers.IUnpackableObject<SetEntityElevationActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):SetEntityElevationAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsSetEntityElevationAction(bb:flatbuffers.ByteBuffer, obj?:SetEntityElevationAction):SetEntityElevationAction {
  return (obj || new SetEntityElevationAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsSetEntityElevationAction(bb:flatbuffers.ByteBuffer, obj?:SetEntityElevationAction):SetEntityElevationAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new SetEntityElevationAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapSetEntityElevation;
}

data(index: number, obj?:EntityElevationUpdate):EntityElevationUpdate|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new EntityElevationUpdate()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

dataLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startSetEntityElevationAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapSetEntityElevation);
}

static addData(builder:flatbuffers.Builder, dataOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, dataOffset, 0);
}

static createDataVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startDataVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endSetEntityElevationAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createSetEntityElevationAction(builder:flatbuffers.Builder, type:ActionType, dataOffset:flatbuffers.Offset):flatbuffers.Offset {
  SetEntityElevationAction.startSetEntityElevationAction(builder);
  SetEntityElevationAction.addType(builder, type);
  SetEntityElevationAction.addData(builder, dataOffset);
  return SetEntityElevationAction.endSetEntityElevationAction(builder);
}

unpack(): SetEntityElevationActionT {
  return new SetEntityElevationActionT(
    this.type(),
    this.bb!.createObjList<EntityElevationUpdate, EntityElevationUpdateT>(this.data.bind(this), this.dataLength())
  );
}


unpackTo(_o: SetEntityElevationActionT): void {
  _o.type = this.type();
  _o.data = this.bb!.createObjList<EntityElevationUpdate, EntityElevationUpdateT>(this.data.bind(this), this.dataLength());
}
}

export class SetEntityElevationActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapSetEntityElevation,
  public data: (EntityElevationUpdateT)[] = []
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const data = SetEntityElevationAction.createDataVector(builder, builder.createObjectOffsetList(this.data));

  return SetEntityElevationAction.createSetEntityElevationAction(builder,
    this.type,
    data
  );
}
}
